import API from "./API";

const USER_MANAGEMENT_PREFIX = "/auth";

export const createNewUserAPI = (payload) => {
  return API.post(`${USER_MANAGEMENT_PREFIX}/create-user`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewRoleAPI = (payload) => {
  const roleName = typeof payload === "string" ? payload : payload?.roleName || "";

  return API.post(
    `${USER_MANAGEMENT_PREFIX}/create-new-role?roleName=${encodeURIComponent(roleName)}`
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllAdminUsersAPI = (payload) => {
  return API.get(`${USER_MANAGEMENT_PREFIX}/all-user?page=${payload?.page||0}&size=${payload?.size||10}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAdminUserAPI = (payload) => {
  return API.get(`${USER_MANAGEMENT_PREFIX}/get-user-detail/${payload?.userId}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllAdminUserRolesAPI = (payload) => {
  return API.get(`${USER_MANAGEMENT_PREFIX}/get-roles`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllPermissionAPI = (payload) => {
  return API.get(`${USER_MANAGEMENT_PREFIX}/get-all-permission`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postAllPermissionAPI = (payload) => {
  return API.post(`${USER_MANAGEMENT_PREFIX}/add-permission`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateUserRoleAPI = (payload) => {
  return API.put(
    `${USER_MANAGEMENT_PREFIX}/update-user-role?userId=${payload?.userId || ""}&roleId=${payload?.roleId || ""}`,
    payload
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
